var xP = require('../xP');

module.exports = {
  name: 'classed', base: '_item', prototype: {
    process: function () {
      xP.debug('classed', 'classed', this.to.first().$element, this.to);

      xP.dependencies.classed.base.process.apply(this);

      var that = this;

      this.to.each(function () {
        if (that.result) {
          this.$container
            .addClass(that['do']);
        } else {
          this.$container
            .removeClass(that['do']);
        }
      });
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/dependencies/classed.js
 ** module id = 42
 ** module chunks = 0
 **/